const DizeeInput = ({ onChange, value, placeholder, className, type, step, pattern }) => {
  return <input value={value} onChange={onChange} placeholder={placeholder} className={`dizee-input text-white ${className}`} type={type} step={step} pattern={pattern} />;
};

export default DizeeInput;
